import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  DeleteCompanyMemberAccessActions as Actions,
  DeleteCompanyMemberAccessRequestAction as RequestAction,
} from 'store/ducks/companyMemberAccesses';

export function* deleteCompanyMemberAccessRequest(action: any) {
  const { id, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.delete, `company-member-accesses/${id}`);
    onSuccess && onSuccess();
    notify('success', 'Acesso ao cliente desvinculado com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
